'use client';

import { AboutUsCard } from '@/components/cards/about-us-card';
import { ImageCard } from '@/components/cards/image-card';
import { SatisfiedClientsCard } from '@/components/cards/satisfied-clients-card';
import { useTranslations } from '@/app/providers';

export function AboutSection() {
  const t = useTranslations();
  return (
    <section id='chi-siamo' className='relative py-28 md:py-34'>
      <div className='container mx-auto px-6 lg:px-0'>
        {/* Responsive grid: 1 column on mobile, 2 columns on desktop */}
        <div className='relative z-10 grid grid-cols-1 lg:grid-cols-3 lg:gap-8'>
        {/* Left column - Desktop: About Us Card + Image Card */}
        <div className='space-y-6 col-span-2 md:space-y-8 flex flex-col'>
          {/* About Us Card */}
          <AboutUsCard
            label={t.about.aboutUs.label}
            title={t.about.aboutUs.title}
            description={[t.about.aboutUs.description1, t.about.aboutUs.description2]}
          />

          {/* Image Card - expands to fill available space */}
          <div className='w-full h-[270px] lg:flex-1 lg:min-h-[276px] lg:h-full'>
            <ImageCard src='/card_image.png' alt={t.about.imageAlt} className='h-full' />
          </div>
        </div>

        {/* Right column - Desktop: Clients Card + What We Do Card */}
        <div className='space-y-6 col-span-1 md:space-y-8 flex flex-col mt-6 lg:mt-0'>
          {/* Satisfied Clients Card */}
          <SatisfiedClientsCard
            count={t.about.satisfiedClients}
            avatars={[
              {
                src: '/placeholder-avatar-1.jpg',
                alt: 'Client 1',
                fallback: 'C1',
              },
              {
                src: '/placeholder-avatar-2.jpg',
                alt: 'Client 2',
                fallback: 'C2',
              },
              {
                src: '/placeholder-avatar-3.jpg',
                alt: 'Client 3',
                fallback: 'C3',
              },
            ]}
          />

          {/* What We Do Card (reusing AboutUsCard with additionalContent) */}
          <div id='cosa-facciamo'>
          <AboutUsCard
            label={t.about.whatWeDo.label}
            title={t.about.whatWeDo.title}
            description={[t.about.whatWeDo.description1, t.about.whatWeDo.description2]}
          >
            
              <p className='text-white text-lg font-medium leading-relaxed border-l-8 border-brand-violet-500 pl-4'>
                {t.about.whatWeDo.additionalText}
              </p>
            
          </AboutUsCard>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
}
